<template>
  <v-row class="mt-1">
    <v-col cols="12">
      <lottie-animation class="anim-success"
          :loop="false"
          :autoPlay="true"
          :width="300"
          :height="300"
          path="animation/success.json"
      ></lottie-animation>
    </v-col>
    <v-col cols="12" class="content-box">
      <h3 class="text-center">ورود شما با موفقیت انجام شد.</h3>
      <v-divider class="mt-8 mb-4"></v-divider>
      <strong>{{ userInfo.fname }} عزیز؛</strong>
      <p>به گویا کلاب (باشگاه مشتریان گویا کارت) خوش آمدید.</p>
      <p>برای استفاده از بی نهایت امکانات گویا کارت وارد سایت شوید.</p>

<!--      <v-btn class="mt-8" color="success" block large dark>ورود به گویا کارت</v-btn>-->
    </v-col>

  </v-row>
</template>
<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
import Vue from "vue";
import {mapState} from "vuex";

export default Vue.extend({
  computed: {
    ...mapState(['userInfo'])
  },
  components: {
    LottieAnimation
  },
});
</script>
<style scoped>
.anim-success{
  margin-top: -50px !important;
}
.content-box{
  margin-top: -80px !important;
}
</style>